import { render } from "./WidgetPicker.vue?vue&type=template&id=6c63eed0&scoped=true"
import script from "./WidgetPicker.vue?vue&type=script&lang=js"
export * from "./WidgetPicker.vue?vue&type=script&lang=js"

import "./WidgetPicker.vue?vue&type=style&index=0&id=6c63eed0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c63eed0"]])

export default __exports__